export type TabMenuItem = {
  label: string;
  dataId: string;
  tag: string;
};

export type CategoryTab = {
  heading: string;
  label: string;
  dataId: string;
  tag: string;
  icon?: string;
  menu: TabMenuItem[];
};

const setWithExpiry = (key: string, data: any, ttl: number = 1 * 60 * 60 * 1000): void => {
  const now = new Date();
  const item = {
    value: data,
    expiry: now.getTime() + ttl,
  };
  window.localStorage.setItem(key, JSON.stringify(item));
};

const getWithExpiry = (key: string): any | null => {
  const itemStr = window.localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr);
    if (new Date().getTime() > item.expiry) {
      window.localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch {
    return null;
  }
};  

export const loadIimjobsCategoriesTabs = async (
  storageKey = 'categories_iimjobs'
): Promise<CategoryTab[]> => {
  try {
    if (process.env.NEXT_PUBLIC_APP_NAME !== 'iimjobs') return [];
    const s3Url = process.env.NEXT_PUBLIC_CATEGORIES_S3_URL as
      | string
      | undefined;
    if (typeof window !== 'undefined') {
      const cached = getWithExpiry(storageKey);
      if (cached) {
        if (Array.isArray(cached) && cached.length > 0) {
          return cached as CategoryTab[];
        }
      }
    }

    if (!s3Url) return [];
    const res = await fetch(s3Url);
    if (!res.ok) return [];
    const json = await res.json();
    const source = Array.isArray(json)
      ? json
      : Array.isArray(json?.category)
      ? json.category
      : [];

    const transformed: CategoryTab[] = source.map((cat: any) => {
      const label = cat?.name || '';
      const dataId = String(cat?.id ?? '');
      const heading = label;
      const tag = cat?.tag || '';
      const icon = cat?.icon || '';
      const tags = Array.isArray(cat?.tags) ? cat.tags : [];
      const menu: TabMenuItem[] = tags.map((t: any) => ({
        label: t?.name || '',
        dataId: String(t?.id ?? ''),
        tag: t?.tag || '',
      }));
      return {heading, label, dataId, tag, menu, icon};
    });

    if (transformed.length > 0 && typeof window !== 'undefined') {
      setWithExpiry(storageKey, transformed);
    }
    return transformed;
  } catch {
    return [];
  }
};
